<template>
  <div>
    <b-modal
        :title="$t('Offline participants')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="xl"
        no-close-on-backdrop lazy>
      <div class="row list-participants">
        <div class="col-md-12 col-lg-6 col-xl-4" v-for="(participant, index) in participants" :key="index">
          <b-card class="participant-item">
            <div class="d-flex">
              <div class="participant-avatar">
                <div class="avatar">
                  <b-icon icon="person-fill"></b-icon>
                </div>
                <button @click="changeStatus(participant)" :class="participant.IsBlocked ? 'status' : 'status active'"
                        v-b-tooltip.hover :title="$t(participant.IsBlocked ? 'Deactivate' : 'Activate')">
                  <b-icon :icon="participant.IsBlocked ? 'lock-fill': 'unlock-fill'"></b-icon>
                </button>
              </div>
              <div class="participant-info">
                <div class="id d-flex justify-content-between">
                  <div>{{ participant.Fullname }}</div>
                  <strong class="trans-id">ID: {{ participant.TransID }}</strong></div>
                <div class="email">
                  <b-icon icon="envelope-fill"></b-icon>
                  <a :href="'mailto:' + participant.Email">{{ participant.Email }}</a></div>
                <div class="phone">
                  <b-icon icon="telephone-fill"></b-icon>
                  <a :href="'tel:' + participant.PhoneNumber">{{ participant.PhoneNumber }}</a></div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "OfflineParticipantsModal",
  data: function () {
    return {
      loading: false,
      show: false,
      participants: []
    }
  },
  methods: {
    async open() {
      this.loading = true;
      let response = await meetingService.offlineParticipants();
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      this.participants = JSON.parse(response.substr(3));
      this.show = true;
    },
    async changeStatus(participant) {
      return;
      this.loading = true;
      let response = await meetingService.blockMeetingParticipant({
        id: participant.ParticipantID,
        isBlocked: !participant.IsBlocked
      })

      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      participant.IsBlocked = !participant.IsBlocked;
      let data = JSON.parse(response.substr(3));
      dialogHelper.alert(data.Msg, "success");
    }
  }
}
</script>

<style scoped>
.list-notifications {
  max-height: 400px;
}
</style>